<template>
  <div id="legend-wrapper">
    <div class="content-layout-fixer">
      <div class="iframe-wrapper">
        <iframe
          v-if="isIframeReady"
          id="legend-iframe"
          ref="legendIframe"
          class="legend-iframe"
          :src="iframeSrc"
          :style="{ height: iframeHeight }"
          title="İncelikte Marlboro Çağı"
          allow="camera"
          sandbox="allow-scripts allow-same-origin allow-forms"
          @load="onIframeDocumentLoad"
        >
        </iframe>
      </div>
    </div>
  </div>
</template>

<script>
import RoutesRoot from '@/router/routes/RoutesRoot';
import user from '@/services/Api/user';
import { getDefaultErrorMessage } from '@/utils/errorExtractor';
import { LEGEND_IFRAME_BASE_URL } from '@/constants/urls.constants';

const IFRAME_EVENT_TYPES = { LOAD: 'LOAD', RESIZE: 'RESIZE', INIT: 'INIT' };
const DEFAULT_IFRAME_HEIGHT = '300px';

export default {
  name: 'LegendHome',

  data() {
    return {
      iframeSrc: '',
      iframeHeight: DEFAULT_IFRAME_HEIGHT,
      isIframeReady: false,
      iframeCode: null,
      isIframeDocumentLoaded: false,
      isIframeInitialized: false,
      isIframeLoaded: false,
    };
  },

  created() {
    window.addEventListener('message', this.handleIframeMessage);

    user
      .generateIframeCode()
      .then(res => {
        const iframeCode = res?.data?.Data?.code;

        if (!LEGEND_IFRAME_BASE_URL) {
          throw new Error('Legend iframe base URL is not configured');
        }

        if (!iframeCode) {
          throw new Error('Iframe code was not returned');
        }

        this.iframeCode = iframeCode;
        this.prepareLegendIframe();
      })
      .catch(error => {
        const errModalConfig = {
          isModalOpened: true,
          modalText: getDefaultErrorMessage(),
          firstButtonFunction: this.goToHomePage,
        };
        this.$store.dispatch('app/setErrorModalConfig', errModalConfig);
        console.error('generateIframeCode error:', error);
      });
  },

  beforeDestroy() {
    window.removeEventListener('message', this.handleIframeMessage);
  },

  methods: {
    prepareLegendIframe() {
      if (!this.iframeCode) return;

      const encodedIframeCode = encodeURIComponent(String(this.iframeCode));

      this.iframeSrc = `${LEGEND_IFRAME_BASE_URL}/p/${encodedIframeCode}`;
      this.isIframeReady = true;
    },

    onIframeDocumentLoad() {
      this.isIframeDocumentLoaded = true;
    },

    handleIframeMessage(event) {
      if (!this.isTrustedIframeMessage(event)) {
        return;
      }

      const { type, payload } = event.data;

      if (type === IFRAME_EVENT_TYPES.INIT) {
        this.isIframeInitialized = true;
      }

      if (type === IFRAME_EVENT_TYPES.LOAD) {
        this.setIframeHeight(payload?.height);
        this.isIframeLoaded = true;
      }

      if (type === IFRAME_EVENT_TYPES.RESIZE) {
        this.setIframeHeight(payload?.height);
      }
    },

    isTrustedIframeMessage(event) {
      if (!event || event.origin !== LEGEND_IFRAME_BASE_URL) {
        return false;
      }

      const iframeWindow = this.$refs.legendIframe?.contentWindow;

      if (!iframeWindow || event.source !== iframeWindow) {
        return false;
      }

      return (
        event.data !== null && typeof event.data === 'object' && typeof event.data.type === 'string'
      );
    },

    setIframeHeight(receivedHeight) {
      const height = Number(receivedHeight);
      if (!Number.isFinite(height) || height <= 0) return;

      this.iframeHeight = `${height}px`;
    },

    goToHomePage() {
      this.$router.push(RoutesRoot.Home.path);
    },
  },
};
</script>

<style lang="scss" scoped>
#legend-wrapper {
  width: 100%;

  .iframe-wrapper {
    width: 100%;
    overflow: hidden;
  }

  .legend-iframe {
    display: block;
    width: 100%;
    border: 0;
  }
}
</style>
